<script setup lang="ts">
import { onMounted, ref, watch } from "vue";
import { getPrize } from "@/api";
import { useGlobalStore } from "@/stores/global";
const startPlay = ref(false);
const star = ref(null);
const isTapGift = ref(false);
const store = useGlobalStore();

const prize = ref<{
  img?: string;
  text: string;
  icon?: string;
  title?: string;
} | null>(null);
const prizeList = {
  3: {
    img: "book",
    text: "Брендированный блокнот",
  },
  2: {
    img: "pen",
    text: "Брендированная ручка",
  },
  1: {
    img: "calendar",
    text: "Брендированный календарик",
  },
  8: {
    title: "0,2%",
    text: "Займ под залог под 0,2% в день сроком на 1 месяц",
  },
  4: {
    icon: "kolco",
    title: "200",
    text: "Сертификат на 200 бонусных рублей, действующий в сети «888» при покупке ювелирных украшений на сумму не менее 2 000 рублей Срок действия сертификата: 60 дней",
  },
  5: {
    icon: "instrument",
    title: "200",
    text: "Сертификат на 200 бонусных рублей, действующий в сети «888» при покупке техники на сумму не менее 2 000 рублей Срок действия сертификата: 60 дней",
  },
  6: {
    icon: "kolco",
    title: "300",
    text: "Сертификат на 300 бонусных рублей, действующий в сети «888» при покупке ювелирных украшений на сумму не менее 5 000 рублей Срок действия сертификата: 60 дней",
  },
  7: {
    icon: "instrument",
    title: "300",
    text: "Сертификат на 300 бонусных рублей, действующий в сети «888» при покупке техники на сумму не менее 5 000 рублей Срок действия сертификата: 60 дней",
  },
  // 10: {
  //   img: '',
  //   text: 'Один день без процентов по займу. Срок действия приза: 60 дней'
  // },
  // 11: {
  //   img: '',
  //   text: 'Два дня без процентов по займу. Срок действия, чтобы воспользоваться призом: 60 дней'
  // },
};

const copyTextToClipboard = () => {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(copyCode.value).then(
      function () {
        alert("Текст успешно скопирован в буфер обмена");
      },
      function (err) {
        alert("Произошла ошибка при копировании текста: ", err);
      }
    );
  } else {
    alert("API буфера обмена не доступно");
  }
};
const copyCode = ref("");
onMounted(() => {
  const prizeNum = window.localStorage.getItem("priz_num");
  const code = window.localStorage.getItem("code");

  if (prizeNum) {
    prize.value = prizeList[prizeNum];

    setTimeout(() => {
      isTapGift.value = true;
    }, 1000);
  }
  if (code) {
    console.log(prize.value);
    copyCode.value = code;
  }
});
watch(star, async () => {
  console.log(store.uid);

  if (store.uid) {
    const { priz_num, code } = await getPrize(store.uid);
    prize.value = prizeList[priz_num];
    window.localStorage.setItem("priz_num", priz_num);
    copyCode.value = code;
    window.localStorage.setItem("code", code);
    return;
  }

  if (window.localStorage.getItem("game-uid")) {
    const uid = JSON.stringify(window.localStorage.getItem("game-uid"));

    const { priz_num, code } = await getPrize(+uid);
    window.localStorage.setItem("priz_num", priz_num);
    prize.value = prizeList[priz_num];
    copyCode.value = code;
    window.localStorage.setItem("code", code);
    return;
  }
});
watch(star, (val) => {
  setTimeout(() => {
    isTapGift.value = true;
  }, 1000);
});
</script>

<template>
  <main class="game" :class="{ start: startPlay }">
    <div v-if="star || prize" class="game__wrapper">
      <div v-if="prize" class="gift" :class="{ active: isTapGift }">
        <div class="gift__box">
          <img class="box-lid" src="@/assets/box-lid.svg" alt="" />

          <div class="gift__name">
            <img
              v-if="prize.img"
              :src="`/public/prizelist/${prize.img}.svg`"
              alt="" />
            <span class="gift__name--content" v-if="prize.title">
              <img
                v-if="prize.icon"
                :src="`/public/prizelist/${prize.icon}.svg`"
                alt="" />
              <span>
                {{ prize.title }}
                <img
                  v-if="prize.icon"
                  src="/public/prizelist/rubl.svg"
                  alt="" />
              </span>
            </span>
          </div>
          <div class="gift__light">
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
          </div>
          <div class="info">
            <span v-if="prize.text" v-html="prize.text"> </span>
            <div class="info__cupon" @click="copyTextToClipboard">
              {{ copyCode }}
            </div>
          </div>
          <div class="clip"></div>
          <img src="@/assets/box.svg" alt="" class="box" />
        </div>
      </div>
    </div>
    <div v-else class="game__wrapper">
      <button class="star" @click="star = 1">
        <span>1</span>
        <img src="@/assets/star.svg" alt="" />
      </button>
      <button class="star" @click="star = 2">
        <span>2</span>
        <img src="@/assets/star.svg" alt="" />
      </button>
      <button class="star" @click="star = 3">
        <span>3</span>
        <img src="@/assets/star.svg" alt="" />
      </button>
      <button class="star" @click="star = 4">
        <span>4</span>
        <img src="@/assets/star.svg" alt="" />
      </button>
      <button class="star" @click="star = 5">
        <span>5</span>
        <img src="@/assets/star.svg" alt="" />
      </button>
      <button class="star" @click="star = 6">
        <span>6</span>
        <img src="@/assets/star.svg" alt="" />
      </button>
      <button class="star" @click="star = 7">
        <span>7</span>
        <img src="@/assets/star.svg" alt="" />
      </button>
      <button class="star" @click="star = 8">
        <span>8</span>
        <img src="@/assets/star.svg" alt="" />
      </button>
      <div class="name">Сеть ломбардов «888» presents</div>
      <img src="@/assets/number.svg" alt="" class="number" />
      <div class="title">
        <div class="title__wrapper">Счастливая 8</div>
      </div>
      <button class="btn-play" @click="startPlay = true">ИГРАТЬ</button>
      <div class="btn-game">
        <span> Выберите звездочку </span>
        <img src="@/assets/starpoint.svg" alt="" />
      </div>
    </div>
  </main>
</template>
<style scoped>
@font-face {
  font-family: "centurygothic";
  src: url("@/assets/fonts/centurygothic_bold.ttf");
  src: local("centurygothic_bold"), local("centurygothic_bold"),
    url("@/assets/fonts/centurygothic_bold.otf") format("otf"),
    url("@/assets/fonts/centurygothic_bold.woff") format("woff");
  font-weight: 700;
  font-style: normal;
}
@font-face {
  font-family: "centurygothic";
  src: url("@/assets/fonts/centurygothic.ttf");
  src: local("centurygothic"), local("centurygothic"),
    url("@/assets/fonts/centurygothic.otf") format("otf"),
    url("@/assets/fonts/centurygothic.woff") format("woff");
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-family: "code_pro_bold";
  src: url("@/assets/fonts/code_pro_bold.ttf");
  src: local("code_pro_bold"), local("code_pro_bold"),
    url("@/assets/fonts/code_pro_bold.otf") format("otf"),
    url("@/assets/fonts/code_pro_bold.woff") format("woff");
  font-weight: 900;
  font-style: normal;
}

.name {
  display: none;
  font-family: centurygothic;
}
.number {
  margin-bottom: 11px;
  /* width: 290px; */
  height: 277px;
}
.game.start .number {
  height: 221px;
}
body {
  overflow: hidden;
}
.game {
  position: absolute;
  width: 100%;
  height: 100%;
  inset: 0;
  display: grid;
  background: url("@/assets/bg.svg") no-repeat center;
  overflow: hidden;
}
.game__wrapper {
  height: 100%;
  margin: auto;
  width: 320px;
  max-height: 100vh;
  display: grid;
  place-content: center;
  overflow: auto;
  justify-items: center;
  position: relative;
}
.game__wrapper > * {
  position: relative;
  z-index: 1;
}
.game::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 350%;
  height: 350%;
  background: url("@/assets/sun.svg") no-repeat center;
  opacity: 0.3;
  z-index: 0;
  animation: 20s linear infinite rotation;
  transform-origin: 50% 50%;
}
@keyframes rotation {
  0% {
    transform: translate(-50%, -50%) rotate(0);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}

.start .title,
.start .title,
.start .btn-play {
  display: none;
}
.game:not(.start) .btn-game,
.game:not(.start) .star {
  display: none;
}
.title {
  position: relative;
  width: fit-content;
  padding: 0 7px;
  margin-bottom: 15px;
}
.title__wrapper {
  background: #d71d23;
  color: #ffffff;
  width: fit-content;
  clip-path: polygon(100% 0, 93% 50%, 100% 100%, 0% 100%, 7% 50%, 0% 0%);
  text-transform: uppercase;

  font-size: 27.35px;
  line-height: 32.81px;
  padding: 7px 24px;
}
.title::before,
.title::after {
  content: "";
  position: absolute;
  background: #d71d23;
  top: 50%;
  transform: translateY(-50%);
  width: 12px;
  height: 12px;
  border-radius: 99999px;
}
.title::before {
  left: 0;
}
.title::after {
  right: 0;
}

.btn-play {
  border: 2px solid #fff;
  background: transparent;
  padding: 10px 55px;
  border-radius: 50px;
  color: #fff;
  cursor: pointer;
  font-size: 20px;
  font-weight: 400;
  line-height: 24.52px;
}
.btn-play:hover {
  opacity: 0.85;
}

.btn-game {
  color: #fff;

  font-weight: 900 !important;
  font-size: 18px;
  line-height: 21.6px;

  display: flex;
  justify-content: center;
  gap: 10px;
  position: absolute;
  bottom: 30px;
  width: 100%;
  white-space: nowrap;
}
.btn-game img {
  width: 27.33px;
  height: 27.33px;
}
.star {
  position: absolute;
  background: transparent;
  border: none;
  width: 65px;
  height: 62px;
  cursor: pointer;

  transform-origin: 50% 0%;
}
@keyframes tick {
  0% {
    transform: rotate(0);
  }
  25% {
    transform: rotate(25deg);
  }
  50% {
    transform: rotate(0deg);
  }
  75% {
    transform: rotate(-25deg);
  }
  100% {
    transform: rotate(0deg);
  }
}

@keyframes tickout {
  0% {
    transform: rotate(0);
  }
  25% {
    transform: rotate(-25deg);
  }
  50% {
    transform: rotate(0deg);
  }
  75% {
    transform: rotate(25deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
.star img {
  width: 100%;
  height: 100%;
}
.star span {
  position: absolute;
  left: calc(50% - 3px);
  top: 50%;
  font-weight: 900;
  transform: translate(-50%, -50%);
  color: #d71d23;

  font-size: 20px;
  line-height: 24px;
}

.star:nth-child(1) {
  left: 77px;
  top: calc(50% - 200px);
  animation: 3s linear 0.1s infinite tick;
}
.star:nth-child(2) {
  left: 18px;
  top: calc(50% - 120px);
  animation: 3s linear 0.2s infinite tick;
}
.star:nth-child(3) {
  left: 14px;
  bottom: calc(50% - 50px);
  animation: 3s linear 0.1s infinite tickout;
}
.star:nth-child(4) {
  left: 48px;
  bottom: calc(50% - 180px);
  animation: 3s linear 0.4s infinite tick;
}
.star:nth-child(5) {
  right: 76px;
  top: calc(50% - 210px);
  animation: 3s linear 0.2s infinite tickout;
}
.star:nth-child(6) {
  right: 22px;
  top: calc(50% - 100px);
  animation: 3s linear 0.6s infinite tickout;
}
.star:nth-child(7) {
  right: 20px;
  bottom: calc(50% - 92px);
  animation: 3s linear 0.8s infinite tick;
}
.star:nth-child(8) {
  right: 77px;
  bottom: calc(50% - 170px);
  animation: 3s linear 1s infinite tick;
}

.gift {
  position: relative;
  margin-left: 50px;
}

.gift .box-lid {
  top: -105px;
  position: absolute;
  z-index: 2;
  width: 184px;
  height: 137px;
  left: -18px;
}

.gift__light {
  margin-bottom: -21px;
  transform: translateX(-26px);
  position: relative;

  clip-path: polygon(100% 4%, 100% 87.32%, 62.67% 100%, 0% 92.17%, 0px 0px);

  height: 0px;
  transition: 0.5s ease;
  width: 188px;
}

.dot {
  width: 30px;
  height: 30px;
  background: radial-gradient(
    rgb(255, 255, 0),
    rgba(199, 199, 0, 0.7),
    rgba(146, 146, 0, 0.02),
    rgba(0, 0, 0, 0.001),
    transparent
  );
  position: absolute;
  opacity: 0;
  transition: all 0.7s ease-in 0.7s;
}

.gift__light::before {
  position: absolute;
  content: "";
  background-blend-mode: screen;
  z-index: 1;
  background: linear-gradient(
    0deg,
    rgba(251, 176, 64, 0.5) 40.53%,
    rgba(198, 139, 51, 0.4) 80.44%,
    rgba(146, 103, 37, 0.08) 90.12%,
    rgba(102, 71, 26, 0.01) 110.05%
      /* rgba(146, 103, 37, 0.3) 34.12%,
    rgba(102, 71, 26, 0.25) 49.05%,
    rgba(65, 46, 17, 0.2) 53.92%,
    rgba(36, 26, 9, 0.1) 68.76%,
    rgba(16, 11, 4, 0.1) 83.55%, */
      /* rgba(4, 3, 1, 0.1) 98.23%, */ /* rgba(0, 0, 0, 0.1) 80.77% */
  );
  clip-path: polygon(100% 4%, 90.13% 100%, 14.93% 100%, 0px 0px);
  width: 100%;
  height: 100%;
  transform: translateY(100%) scale(0.3);
  transition: 1s ease;
}

.gift__light .dot:nth-child(1) {
  transform: scale(0.5);
  left: 22px;
  bottom: 20px;
}
.gift__light .dot:nth-child(2) {
  transform: scale(0.6);
  left: 20px;
  bottom: 65px;
}
.gift__light .dot:nth-child(3) {
  transform: scale(0.5);
  left: 70px;
  bottom: 20px;
}
.gift__light .dot:nth-child(4) {
  transform: scale(0.7);
  left: 58px;
  bottom: 46px;
}
.gift__light .dot:nth-child(5) {
  transform: scale(0.5);
  left: 55px;
  bottom: 83px;
}
.gift__light .dot:nth-child(6) {
  transform: scale(0.6);
  left: 100px;
  bottom: 10px;
}
.gift__light .dot:nth-child(7) {
  transform: scale(0.5);
  left: 88px;
  bottom: 40px;
}
.gift__light .dot:nth-child(8) {
  transform: scale(0.6);
  left: 156px;
  bottom: 0px;
}
.gift__light .dot:nth-child(9) {
  transform: scale(0.6);
  right: 136px;
  bottom: 28px;
}
.gift__light .dot:nth-child(10) {
  transform: scale(0.4);
  right: 106px;
  bottom: 8px;
}
.gift__light .dot:nth-child(11) {
  transform: scale(0.9);
  right: 60px;
  bottom: 35px;
}
.gift__light .dot:nth-child(12) {
  transform: scale(0.4);
  right: 76px;
  bottom: 55px;
}
.gift__light .dot:nth-child(13) {
  transform: scale(0.6);
  right: 35px;
  bottom: 64px;
}
.gift__light .dot:nth-child(14) {
  transform: scale(0.5);
  right: 60px;
  bottom: 80px;
}
.gift__light .dot:nth-child(15) {
  transform: scale(0.7);
  right: 28px;
  bottom: 94px;
}

.gift .box {
  width: 152px;
  height: 120px;
}
.gift__box {
  position: relative;
  display: grid;
}

.gift.active .dot {
  opacity: 1;
}
.gift.active .gift__light {
  height: 141px;
}
.gift.active .gift__light::before {
  transform: translateY(0%) scale(1);
}

.gift__name {
  max-height: 90px;
  bottom: 110px;
  margin-left: -13px;
  font-family: code_pro_bold;
  font-weight: 900 !important;
  color: #fff;
  text-align: center;

  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;
  opacity: 1;
  display: flex;
  white-space: nowrap;

  line-height: 100%;
  font-size: 50px;

  /* transform: translateY(150px); */
  opacity: 0;
  transition: all 0.5s ease-in 1s;
}
.gift__name {
  display: flex;
  justify-content: center;
  bottom: 120px;
}
.gift__name--content {
  display: grid;
  justify-items: center;
}
.gift__name--content > img {
  width: 40px;
  margin-bottom: 10px;
}
.gift__name--content > span > img {
  width: 25px;
}
.gift__name > img {
  margin: auto;
  /* width: 100%; */
  height: 100%;
}
.gift.active .gift__name {
  opacity: 1;
}
.info {
  font-family: centurygothic;
  position: absolute;
  right: 50%;
  transform: translate(calc(50% + -25px), calc(100% + 9px));
  bottom: 0%;

  font-size: 20px;
  font-weight: 700 !important;
  line-height: 24.52px;

  text-align: center;
  display: grid;
  justify-items: center;
  align-content: start;
  gap: 9px;
  color: #fff;
  opacity: 0;
  transition: all 1s ease 1.1s;
  width: 90vw;
}

.info__cupon {
  padding: 8px 22px;
  border-radius: 32px;
  background: #fff;
  width: fit-content;
  font-family: centurygothic;
  font-size: 24px;
  font-weight: 700 !important;
  line-height: 100%;
  cursor: pointer;
  color: #000;
}
.gift.active .info {
  opacity: 1;
}
@media (min-width: 1200px) {
  .name {
    padding: 12px 35px;
    background: #d71d23;
    color: #fff;
    border-radius: 50px;
    font-size: 28.99px;

    line-height: 35.55px;
    margin-bottom: 42px;
    display: block;
  }
  .start .name {
    display: none;
  }
  .game__wrapper {
    width: 1200px;
    max-height: 900px;
    height: 100%;
    margin: auto;
    border: 1px solid black;
    display: grid;
    place-content: center;

    justify-items: center;
    position: relative;
  }
  .title {
    margin-bottom: 35px;
    padding: 0 15px;
  }
  .title__wrapper {
    padding: 15px 62.63px;
    font-weight: 900;
    font-size: 68.77px;

    line-height: 82.53px;
  }
  .title::before,
  .title::after {
    width: 30px;
    height: 30px;
  }

  .btn-play {
    border: none;
    background: #d71d23;
    padding: 20px 70px;
    border-radius: 50px;
    color: #fff;
    cursor: pointer;
    font-size: 28.99px;
    font-weight: 700;
    line-height: 35.55px;
  }

  .btn-game {
    font-size: 42px;
    line-height: 51.5px;
    background: #d71d23;
    padding: 22px 49px;
    border-radius: 50px;
    width: fit-content;
  }
  .btn-game img {
    width: 55px;
    height: 55px;
  }
  .number {
    margin-bottom: 14px;
    /* width: 290px; */
    height: 460px;
  }
  .game.start .number {
    height: 634px;
    margin-bottom: 35px;
  }
  .star {
    width: 140px;
    height: 134px;
  }
  .star span {
    font-size: 57.19px;
    line-height: 68.63px;
  }
  .star:nth-child(1) {
    left: 202px;
    top: 99px;
  }
  .star:nth-child(2) {
    left: 89px;
    top: 284px;
  }
  .star:nth-child(3) {
    left: 213px;
    top: 475px;
  }
  .star:nth-child(4) {
    left: 57px;
    top: 616px;
  }
  .star:nth-child(5) {
    right: 227px;
    top: 58px;
  }
  .star:nth-child(6) {
    right: 107px;
    top: 237px;
  }
  .star:nth-child(7) {
    right: 218px;
    top: 431px;
  }
  .star:nth-child(8) {
    right: 68px;
    top: 576px;
  }

  .gift .box {
    width: 303px;
    height: 239px;
  }

  .gift .box-lid {
    width: 356px;
    height: 266px;
    top: -174px;
    left: -18px;
  }
  .gift__name {
    max-height: 180px;
    bottom: 239px;
    margin-left: -25px;
    font-size: 90.43px;
    line-height: 108.52px;
  }
  .gift__name--content > img {
    width: 50px;
  }
  .gift__name--content > span > img {
    width: 50px;
  }
  .gift .box-lid {
    top: -174px;
  }
  .gift__light {
    width: 375px;
    margin-bottom: -40px;
    transform: translateX(-50px);
  }
  .gift.active .gift__light {
    height: 282px;
  }

  .info {
    position: absolute;
    right: 0;
    transform: translate(100%, -50%);
    top: 50%;
    font-size: 24px;
    font-weight: 700;
    line-height: 29.43px;
    text-align: center;
    display: grid;
    justify-items: center;
    gap: 24px;
    color: #fff;
    opacity: 0;
    transition: all 1s ease 1.1s;
    width: auto;
  }
  .info__cupon {
    padding: 8px 22px;
    border-radius: 32px;
    background: #fff;
    width: fit-content;
    font-family: Century Gothic;
    font-size: 24px;
    font-weight: 700;
    line-height: 100%;
    color: #000;
  }
}
</style>
